export const isArrayOfString = (items: any[]) =>
  items.every((i) => typeof i === "string");
